module.exports = __webpack_public_path__ + "static/media/Icond-7.4307deef.svg";